import ShowcaseContent from "./ShowcaseContent";
import ShowcaseInput from "./ShowcaseInput";
import ShowcaseTextarea from "./ShowcaseTextarea";
import React, { useState, useEffect } from "react";
import SanityClient from "../../../utils/Sanity";
import groq from "groq";

const ShowcaseSection = (id: any) => {
  const [section, setSection] = useState<any>(null);

  useEffect(() => {
    const query = groq`*[_type=="sopSection" && _id=="${id.id}"][0]`;
    SanityClient.fetch(query).then((res) => {
      setSection(res);
    });
  }, [id]);

  return (
    <div className="flex md:flex-row flex-col gap-4">
      {/* Final SOP */}
      <ShowcaseContent
        key={section?._id}
        header={section?.title}
        content={section?.output}
      />

      {/* Inputs */}
      <div className="lg:basis-1/4 md:basis-1/3 basis-1/2 my-5 px-4 md:px-0">
        <div className="flex flex-col gap-4 pt-6">
          {section?.inputs?.map((input: any) =>
            input.length > 50 ? (
              <ShowcaseTextarea
                key={input.id}
                label={input.label}
                value={input.value}
              />
            ) : (
              <ShowcaseInput
                key={input.id}
                label={input.label}
                value={input.value}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ShowcaseSection;
